// @ts-nocheck
import styled from "styled-components";
import React from "react";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Colors } from "../constants/colors";

export const ContactInputContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.medium,
    padding: `${theme.spacing.medium} ${theme.spacing.small}`,
    position: "relative",
    zIndex: 1,
}));

export const StyledFullWidthButton = styled(FullWidthButton)(({ theme, isDisabled }) => {
    return {
        backgroundColor: isDisabled ? theme.colors[theme.colorMode].primary_Sub : undefined,
    }
});

export const CityInputContainer = styled.div({
    position: "relative",
});

export const IconWrapper = styled.div(({ theme }) => ({
    position: "absolute",
    right: theme.spacing.medium,
    top: "50%",
    transform: "translateY(-50%)",
}));

export const CityInput = styled.select<React.SelectHTMLAttributes<HTMLSelectElement>>(({ theme }) => ({
    width: "100%",
    borderRadius: theme.spacing.medium,
    borderWidth: 1,
    borderColor: theme.colors[theme.colorMode].border_Secondary,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    paddingLeft: theme.spacing.medium,
    paddingTop: theme.spacing.medium,
    paddingBottom: theme.spacing.medium,
    appearance: "none",
    "&:focus": {
        borderColor: theme.colors[theme.colorMode].primary,
        outline: "none",
    },
    "&:disabled": {
        backgroundColor: theme.colors[theme.colorMode].background_Secondary,
    },
}));

export const LoaderContainer = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});
